import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { RequireBusinessProfile } from './components/auth/RequireBusinessProfile';
import { Layout } from './components/layout/Layout';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Converter from './pages/Converter';
import History from './pages/History';
import Mappings from './pages/Mappings';
import MappingEditor from './pages/MappingEditor';
// Subscription page moved to Settings - keeping import for backwards compatibility redirect
import Settings from './pages/Settings';
import NIBSubmissions from './pages/nib/NIBSubmissions';
import NIBSubmissionNew from './pages/nib/NIBSubmissionNew';
import { NIBSubmissionDetail } from './pages/nib/NIBSubmissionDetail';
import { NIBCalculator } from './pages/nib/NIBCalculator';
import ManualEntryPage from './pages/manual-entry';
import Onboarding from './pages/Onboarding';
import { FilingHistoryPage } from './pages/filings';
import { ConversionWizard } from '@/pages/conversion-wizard';
import EmployeeRoster from './pages/roster/EmployeeRoster';
import NotFound from './pages/NotFound';
import Landing from './pages/Landing';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding" element={<Onboarding />} />
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            />
            <Route
              path="/converter"
              element={
                <Layout>
                  <Converter />
                </Layout>
              }
            />
            <Route
              path="/history"
              element={
                <Layout>
                  <History />
                </Layout>
              }
            />
            <Route
              path="/mappings"
              element={
                <Layout>
                  <Mappings />
                </Layout>
              }
            />
            <Route
              path="/mappings/new"
              element={
                <Layout>
                  <MappingEditor />
                </Layout>
              }
            />
            <Route
              path="/mappings/:id"
              element={
                <Layout>
                  <MappingEditor />
                </Layout>
              }
            />
            {/* Redirect /subscription to settings subscription tab */}
            <Route
              path="/subscription"
              element={<Navigate to="/settings?tab=subscription" replace />}
            />
            <Route
              path="/settings"
              element={
                <Layout>
                  <Settings />
                </Layout>
              }
            />
            {/* Filing History - Session 3.2 */}
            <Route
              path="/filings"
              element={
                <Layout>
                  <FilingHistoryPage />
                </Layout>
              }
            />
            {/* Conversion Wizard - Session 4.1 */}
            <Route path="/converter/wizard" element={<Layout><ConversionWizard /></Layout>} />
            {/* NIB routes - require business profile */}
            <Route element={<RequireBusinessProfile />}>
              <Route
                path="/roster"
                element={
                  <Layout>
                    <EmployeeRoster />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/submissions"
                element={
                  <Layout>
                    <NIBSubmissions />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/submissions/new"
                element={
                  <Layout>
                    <NIBSubmissionNew />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/submissions/:id"
                element={
                  <Layout>
                    <NIBSubmissionDetail />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/calculator"
                element={
                  <Layout>
                    <NIBCalculator />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/manual-entry"
                element={
                  <Layout>
                    <ManualEntryPage />
                  </Layout>
                }
              />
              <Route
                path="/nib-c10/manual-entry/:submissionId"
                element={
                  <Layout>
                    <ManualEntryPage />
                  </Layout>
                }
              />
            </Route>
          </Route>

          {/* Public landing page */}
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
